<template>
    <div class="plantillaproyecto">
        <Navbar/>
        <b-container fluid>
            <b-row class="assets">
                <b-col class="pl-0 pr-0">
                    <VueSlickCarousel v-bind="slickOptions" :arrows="true" :dots="false">
                        <div>
                            <img class="img-fluid" src="../assets/imgs/fachadaeliza1.png" alt="">
                        </div>
                        <div>
                            <img class="img-fluid" src="../assets/imgs/fachadaeliza2.png" alt="">
                        </div>
                        <div>
                            <img class="img-fluid" src="../assets/imgs/fachadaeliza3.png" alt="">
                        </div>
                    </VueSlickCarousel>
                </b-col>
            </b-row>
        </b-container>
        <b-container>
            <b-row class="text-center mt-5 mb-5">
                <b-col>
                    <h3>Modelo Eliza</h3>
                </b-col>
            </b-row>
        </b-container>
        <b-container class="folleto">
            <b-row class="folletoinner">
                <b-col class="text-center mb-3" lg="12">
                    <div class="folleto-div">
                        <h3 class="mb-0">Descarga nuestro brochure</h3>
                        <p>Conoce más acerca de nuestros modelos</p>
                        <b-button class="btn-modal" v-b-modal.modal-center>Descargar <img src="../assets/imgs/arrow5.svg"></b-button>
                    </div>
                </b-col>
                <b-modal id="modal-center" class="eliza" size="xl" hide-header hide-footer centered>
                <b-row class="folleto-wrapper">
                    <b-col lg="12">
                        <h3>Descarga nuestro brochure</h3>
                        <p>Descarga toda la información acerca de nuestro proyecto y modelos.</p>
                        <p class="error" v-if="messageSendFolleto">{{ messageSendFolleto }}</p>
                    </b-col>
                    <b-col lg="6">
                        <b-form-input class="mb-1" id="input-1-f" v-model="nameFolleto" placeholder="Nombre:" type="text"></b-form-input>
                        <b-form-input class="mb-1" id="input-2-f" v-model="emailFolleto" placeholder="Email:" type="text"></b-form-input>
                        <b-form-input class="mb-1" id="input-3-f" v-model="phoneFolleto" placeholder="Teléfono:" type="text"></b-form-input>
                        <b-form-input autocomplete="off" tabindex="-1" id="input-1" class="pet-field" v-model="pet" placeholder="Alimento de mascota" type="text"></b-form-input>
                    </b-col>
                    <b-col lg="6">
                        <b-form-textarea class="mb-2" id="input-3" v-model="messageFolleto" placeholder="Mensaje" rows="6" max-rows="3"></b-form-textarea>
                        <b-button class="btn btn-download" v-on:click="sendDownload('pdf/SAM-PresentacionDigital.pdf', 'SAM-PresentacionDigital')">Descargar <img src="../assets/imgs/arrow5.svg"></b-button>
                    </b-col>
                </b-row>
                </b-modal>
            </b-row>
        </b-container>
        <b-container class="interiores" fluid>
            <b-row class="text-center mb-4">
                <b-col>
                    <h4>Interiores</h4>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3" class="mb-5" align-self="center">
                    <p>Sala y comedor</p>
                </b-col>
                <b-col class="text-right pr-0 mb-5" align-self="center">
                    <img src="../assets/imgs/eliza1.png" alt="">
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3" class="mb-5" align-self="center">
                    <p>Cocina</p>
                </b-col>
                <b-col class="text-right pr-0 mb-5" align-self="center">
                    <img src="../assets/imgs/eliza2.png" alt="">
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3" class="mb-5" align-self="center">
                    <p>Recámara principal</p>
                </b-col>
                <b-col class="text-right pr-0 mb-5" align-self="center">
                    <img src="../assets/imgs/eliza3.png" alt="">
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3" class="mb-5" align-self="center">
                    <p>Baño con walk-in-closet</p>
                </b-col>
                <b-col class="text-right pr-0 mb-5" align-self="center">
                    <img src="../assets/imgs/eliza4.png" alt="">
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3" class="mb-5" align-self="center">
                    <p>Recámara 2 </p>
                </b-col>
                <b-col class="text-right pr-0 mb-5" align-self="center">
                    <img src="../assets/imgs/eliza5.png" alt="">
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3" class="mb-5" align-self="center">
                    <p>Recámara 3 con walk-in-closet</p>
                </b-col>
                <b-col class="text-right pr-0 mb-5" align-self="center">
                    <img src="../assets/imgs/eliza6.png" alt="">
                </b-col>
            </b-row>
        </b-container>
        <Contact/>
        <div class="whatsapp">
            <a href="https://api.whatsapp.com/send/?phone=526863912095&amp;app_absent=0" target="_blank">
                <img src="../assets/imgs/whatsapp.png" alt="Whatsapp">
            </a>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import Navbar from '../components/Navbar.vue'
    import Contact from '../components/Contact.vue'
    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    // optional style for arrows & dots
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
    export default {
        components: {
            VueSlickCarousel,
            Navbar,
            Contact
        },
        data() {
            return {
                slickOptions: {
                    autoplay: true,
                    autoplaySpeed: 10000,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    focusOnSelect: true,
                    speed: 1000,
                },
                nameFolleto: '',
                emailFolleto: '',
                phoneFolleto:'',
                messageFolleto:'',
                messageSendFolleto: '',
                pet: ''
            }
        },
        methods: {
            sendDownload: async function(url, title){
            var responseData
            const current = new Date();
            const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
            if(this.nameFolleto != '' && this.emailFolleto != '' && this.phoneFolleto != '' && this.pet == ''){
                await axios.post('https://api.sheety.co/e553147cf9a67a1f2e3d0f6c773f39bb/leadsSam/landingPage', {
                landingPage: {
                    nombre: this.nameFolleto,
                    correo: this.emailFolleto,
                    telefono: this.phoneFolleto,
                    fecha: date
                }
                })
                .then((response) => {
                responseData = response.data
                })
                .catch((error) => {
                /* eslint-disable no-console */
                console.log(error);
                /* eslint-enable no-console */
                });
                if(responseData) {
                this.nameFolleto = ''
                this.emailFolleto = ''
                this.phoneFolleto = ''
                this.messageSendFolleto = 'Mensaje enviado'
                axios.get(url, {
                    responseType: 'arraybuffer'
                }).then(function (response) {
                    const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', title)
                    document.body.appendChild(link)
                    link.click()
                })
                .catch(function (error) {
                /* eslint-disable no-console */
                console.log(error)
                /* eslint-enable no-console */
                })
                } else {
                this.messageSendFolleto = 'Error al enviar mensaje, intenta mas tarde.'
                }
            } else {
                this.messageSendFolleto = 'Ingresa la información necesaria en los campos.'
            }
            }
        },
        created () {
        },
        destroyed () {
        }
    }
</script>

<style scoped>
.plantillaproyecto{
    margin-top: 100px;
}
/* BANNER */
.banner{
  min-height: 100vh;
  background-image: url('../assets/imgs/imgbanner.png'); /* The image used */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}
.banner h1{
  font-size: 80px;
  font-weight: 600;
  line-height: 120px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #fff;
  text-shadow: 1px 1px 2px #00000060;
  margin-top: 30%;
}
.banner h3{
  font-size: 30px;
  font-weight: 600;
  line-height: 45px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #fff;
  text-shadow: 1px 1px 2px #00000060;
}

/* PROYECTOS */
.proyectos{
    padding: 10% 5%;
}
.proyectos .text{
    max-width: 800px;
    margin-bottom: 60px !important;
}
.wrapper-proyectos-logos{
    padding: 2% 10%;
    box-shadow: 0px 14px 38.7px -5px #9C9C9C4D;
    border-radius: 10px;
}

/* FOLLETO */
.folleto{
    padding: 35px 50px;
    border-radius: 30px;
    background: #C5C297;
}
.folletoinner{
    padding: 50px;
    background: #fff;
    border-radius: 30px;
}
.btn-modal{
    font-weight: 500;
    color: #fff !important;
    font-size: 20px;
    background: #9C9B88 !important;
    border: none;
    width: 190px;
    height: 40px;
    border-radius: 50px;
}
.folleto-div img{
  max-width: 522px;
}

.folleto-wrapper{
  background: #C5C297;
  border-radius: 20px;
  color: #fff;
  padding: 5% 10%;
}
.folleto-wrapper .form-control{
  border: 1px solid #C5C297;
  height: 65px;
  color: #000;
  font-size: 20px;
  margin-bottom: 15px !important;
  border-radius: 5px;
}

.folleto-wrapper textarea.form-control{
  height: 140px;
}
.btn-download{
  background: #9C9B88 !important;
  border-radius: 50px;
  color: #FFF !important;
  border: none !important;
  height: 70px;
  max-width: 350px;
  width: 100%;
  font-weight: 600;
  font-size: 20px;
}
.pet-field{
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      height: 0;
      width: 0;
      z-index: -1;
  }

  .assets img{
    width: 100%;
}

/* INTERIORES */
.interiores{
    padding: 5% 7% 5% 10%;
}
.interiores img{
    width: 100%;
}

@media (max-width: 992px) {
    .plantillaproyecto{
        margin-top: 60px;
    }
}
@media (max-width: 768px) {

}
</style>